<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
      return{
          windowWidth:document.documentElement.clientWidth
      }
  },
  created(){

  },
  watch: {
  '$store.state.screenWidth': function (val) { //全局监听屏幕宽度变化
    this.windowWidth = val;
  }
},
  mounted(){
    let that = this;
      window.onresize=function() {
      that.$store.commit('change',{width:document.documentElement.clientWidth,height:document.documentElement.clientHeight})  
    }
  },
  methods:{

  }
}
</script>

<style lang="less"  scoped>
@import "./assets/font/font.css";
</style>



// WEBPACK FOOTER //
// src/App.vue